import Config from '../utils/Config';

export default class SwitchButton extends Phaser.Group {

    constructor(game, x = 0, y = 0)
    {
        super(game);

        this.position.set(x, y);

        this.onSwitch = new Phaser.Signal();
        this._checked = false;
        
        let view = this._view = new Phaser.Image(game, 0, 0, 'buttons.checkbox');
        view.inputEnabled = true;
        view.events.onInputUp.add(() =>
        {
            this.checked = !this.checked;
        });
        this.addChild(view);

        let onLabel = new Phaser.Text(game, -2, (view.height >> 1) + 2, 'on', {
            fill: '#FFFFFF',
            fontSize: 14,
            font: Config.DEFAULT_FONT,
            fontWeight: 'bold'
        });
        onLabel.anchor.set(1, 0.5);
        this.addChild(onLabel);

        let offLabel = new Phaser.Text(game, view.width + 2, (view.height >> 1) + 2, 'off', {
            fill: '#FFFFFF',
            fontSize: 14,
            font: Config.DEFAULT_FONT,
            fontWeight: 'bold'
        });
        offLabel.anchor.set(0, 0.5);
        this.addChild(offLabel);

        this.checked = false;
    }

    get checked()
    {
        return this._checked || false;
    }

    set checked(value)
    {
        let oldValue = this._checked;      
        this._checked = !!value;
        this._view.frame = this._checked ? 0 : 1;
        
        if( this._checked !== oldValue ) this.onSwitch.dispatch(this, this._checked);
    }
}